
        // generated by Jenkins
        export default {
          oauth_consumer_key: "blya2u69edihsbk6l1c6gx6sx6a8fdq9",
          oauth_consumer_secret: "1wo9npnulxl19t1truub79x9678swrq4",
        };
        